import { createContext } from "react";

const ConexContext = createContext();

export default ConexContext;